<template>
  <div class="blog-area ptb-100">
    <div class="container mw-1356">
      <div class="section-title m-auto text-center mw-860">
        <span class="top-title">BLOG</span>
        <h2>Our latest articles to show</h2>
      </div>

      <div class="row">
        <div class="col-lg-9 order-2 order-lg-1">
          <div class="row justify-content-center">
            <div
              v-for="(blog, index) in paginatedTestimonials"
              :key="index"
              class="col-xl-4 col-md-6"
            >
              <div class="blog-single-item transition-y">
                <RouterLink :to="blog.link" class="d-block blog-img">
                  <img :src="blog.image" :alt="blog.title" />
                </RouterLink>

                <div class="blog-content">
                  <RouterLink :to="blog.tagLink" class="tag">{{
                    blog.category
                  }}</RouterLink>
                  <h3>
                    <RouterLink :to="blog.link">{{ blog.title }}</RouterLink>
                  </h3>
                  <ul class="d-flex align-items-center flex-wrap ps-0 mb-0">
                    <li class="d-flex align-items-center">
                      <i class="ti ti-calendar-week"></i>
                      <span>{{ blog.date }}</span>
                    </li>
                    <li class="d-flex align-items-center">
                      <i class="ti ti-clock"></i>
                      <span>{{ blog.readTime }} mins read</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <div class="pagination-area text-center mt-4">
                <span
                  class="next page-numbers"
                  :class="{ disabled: currentPage === 1 }"
                  @click="prevPage"
                >
                  <i class="ri-arrow-left-s-line"></i>
                </span>

                <span
                  v-for="page in totalPages"
                  :key="page"
                  class="page-numbers"
                  :class="{ current: currentPage === page }"
                  @click="goToPage(page)"
                >
                  {{ page }}
                </span>

                <span
                  class="next page-numbers"
                  :class="{ disabled: currentPage === totalPages }"
                  @click="nextPage"
                >
                  <i class="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-3 order-1 order-lg-2 mb-5 mb-lg-0">
          <SidebarWidget />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import SidebarWidget from "../Blog/SidebarWidget.vue";

export default defineComponent({
  name: "BlogCategories",
  components: {
    SidebarWidget,
  },
  setup() {
    // المقالات الأساسية التسعة (9)
    const blogs = ref([
      { image: require("@/assets/images/blog-4.jpg"), category: "COMMUNITY", tagLink: "/tags", title: "كيف تضبط إعدادات سيرفر الـ IPTV للحصول على أعلى ثبات؟", link: "/blog-details/1", date: "23 Jan, 2026", readTime: 5 },
      { image: require("@/assets/images/blog-2.jpg"), category: "KNOWLEDGE", tagLink: "/tags", title: "أفضل مشغلات IPTV لأجهزة أندرويد وشاشات سمارت", link: "/blog-details/2", date: "22 Jan, 2026", readTime: 4 },
      { image: require("@/assets/images/blog-3.jpg"), category: "KNOWLEDGE", tagLink: "/tags", title: "دليلك الشامل لتركيب Fire TV Stick مع اشتراكك", link: "/blog-details/3", date: "21 Jan, 2026", readTime: 6 },
      { image: require("@/assets/images/blog-5.jpg"), category: "COMMUNITY", tagLink: "/tags", title: "لماذا يفضل المحترفون اشتراكات IPTV الخاصة بنا؟", link: "/blog-details/4", date: "20 Jan, 2026", readTime: 3 },
      { image: require("@/assets/images/blog-6.jpg"), category: "KNOWLEDGE", tagLink: "/tags", title: "حل مشاكل التقطيع أثناء مباريات كرة القدم المباشرة", link: "/blog-details/5", date: "19 Jan, 2026", readTime: 5 },
      { image: require("@/assets/images/blog-7.jpg"), category: "KNOWLEDGE", tagLink: "/tags", title: "فهم جودة 4K والفرق بينها وبين Full HD في البث", link: "/blog-details/6", date: "18 Jan, 2026", readTime: 4 },
      { image: require("@/assets/images/blog-8.jpg"), category: "COMMUNITY", tagLink: "/tags", title: "كيف تحمي خصوصيتك عند استخدام خدمات البث", link: "/blog-details/7", date: "17 Jan, 2026", readTime: 4 },
      { image: require("@/assets/images/blog-9.jpg"), category: "KNOWLEDGE", tagLink: "/tags", title: "خطوات تفعيل اشتراكك في أقل من دقيقة", link: "/blog-details/8", date: "16 Jan, 2026", readTime: 2 },
      { image: require("@/assets/images/blog-10.jpg"), category: "KNOWLEDGE", tagLink: "/tags", title: "أهم الميزات المخفية في تطبيق IPTV الخاص بنا", link: "/blog-details/9", date: "15 Jan, 2026", readTime: 5 }
    ]);

    const currentPage = ref(1);
    const itemsPerPage = ref(9);

    const totalPages = computed(() => Math.ceil(blogs.value.length / itemsPerPage.value));

    const paginatedTestimonials = computed(() => {
      const start = (currentPage.value - 1) * itemsPerPage.value;
      return blogs.value.slice(start, start + itemsPerPage.value);
    });

    const goToPage = (page: number) => { if (page >= 1 && page <= totalPages.value) currentPage.value = page; };
    const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++; };
    const prevPage = () => { if (currentPage.value > 1) currentPage.value--; };

    return { currentPage, paginatedTestimonials, totalPages, goToPage, nextPage, prevPage };
  },
});
</script>